import {ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {FormBuilder, FormControl} from "@angular/forms";
import {MedicineListComponent} from "../medicine-list/medicine-list.component";
import {SessionActions} from "../../../shared/actions/session.actions";
import {MedicineService} from "../../services/medicine.service";

@Component({
  selector: 'vb-medicines-view',
  templateUrl: './medicines-view.component.html',
  styleUrls: ['./medicines-view.component.css']
})
export class MedicinesViewComponent extends AbstractVisbosComponent implements OnInit {

  searchTerm: FormControl = new FormControl();

  @ViewChild('medicineList')
  medicineList: MedicineListComponent;

  constructor(sessionActions: SessionActions, private medService: MedicineService, private fb: FormBuilder, cd: ChangeDetectorRef) {
    super(sessionActions, cd);

  }

  ngOnInit() {
    super.ngOnInit();
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/medicine/medicines-view/medicines-view.component.ts